import React from 'react';
import resume, { Certification } from '../../data/resume';
import styles from './Certifications.module.css';

interface CertCardProps {
  cert: Certification;
}

const CertCard: React.FC<CertCardProps> = ({ cert }) => (
  <div className={styles.card}>
    <div className={styles.header}>
      <a href={cert.url} target="_blank" rel="noopener noreferrer" className={styles.name}>
        {cert.name}
      </a>
      <span className={styles.issuer}>{cert.issuer}</span>
    </div>
    {cert.courses.length > 0 && (
      <ul className={styles.courses}>
        {cert.courses.map((course, i) => (
          <li key={i} className={styles.course}>
            <span className={styles.dot} />
            <a href={course.url} target="_blank" rel="noopener noreferrer" className={styles.courseLink}>
              {course.name}
            </a>
          </li>
        ))}
      </ul>
    )}
  </div>
);

const Certifications: React.FC = () => (
  <section id="certifications" className={styles.section}>
    <div className={styles.inner}>
      <h2 className={styles.sectionTitle}>Certifications</h2>
      <div className={styles.list}>
        {resume.certifications.map((cert, i) => (
          <CertCard key={i} cert={cert} />
        ))}
      </div>
    </div>
  </section>
);

export default Certifications;
